import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';
export var DisclosureArrow = function DisclosureArrow(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      open = _ref.open,
      svgClassName = _ref.svgClassName;
  return React.createElement("span", {
    onClick: onClick,
    className: classNames('disclosure-arrow', className, {
      'disclosure-arrow--open': open
    })
  }, React.createElement(Isvg, {
    className: classNames('svg', svgClassName),
    uniquifyIDs: false,
    src: require('../../../static/design-system/icons/arrow-down-small.svg')
  }));
};
DisclosureArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  open: PropTypes.bool,
  svgClassName: PropTypes.string
};